import { render, staticRenderFns } from "./DashboardLevel.vue?vue&type=template&id=2d84af1d&"
import script from "./DashboardLevel.vue?vue&type=script&lang=js&"
export * from "./DashboardLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports